import { dark } from "@mui/material/styles/createPalette";
import { captions, typography } from "app/utils/constant";

// Text colors from PDF
const textLight = {
   Background: "#ffffff",   // E.g Page background
  CardBackground: "#ffffff", // e.g card background  
  SectionBackground: "#f2f4f5", // e.g background for list like language,skills,etc.,
  Border: "#d1d5d8", // e.g Button or List or Card Border
  InputBackground: '#F9FAFB', // input text box background colour
  SpecialButtonBackground: '#FEF7FF', // e.g Send OTP
  TextPrimary: "#1a1a1a",  // e.g all text for Label,Text
  TextSecondary: "rgba(0,0,0,0.54)", // e.g for  lable below heading or outside text box
  TextDisabled: "rgba(77,77,77,0.4)", // e.g for placeholder text
  TextAccent: "#007aff",  // e.g for hyperlink or link like Add more
  loader: "#1a1a1a",  // e.g for Activity Indicator 
  IconColor: "#1a1a1a",  // e.g for icon and Image Colour 

  BrandPrimary: "#f25e21",  // Special Button text e.g Send OTP
  BrandSecondary: "#19495c",

  ButtonPrimaryBG: "#f25e21",      // e.g Primary Button background Like contiue
  ButtonPrimaryText: "#ffffff",    // e.g Primary Button text colour 
  ButtonSecondaryBG: "#19495c",   // e.g Secndary Button background Like uploadphoto
  ButtonSecondaryText: "#ffffff", // e.g Secndary Button text Like uploadphoto
  ButtonGhostIcon: "#505050",

  Success: "#2e9e4d",    // e.g for Success Toast Colour
  Warning: "#f5a623",   // e.g for Warning Toast Colour
  Error: "#ff3b30",    // e.g for Error Toast Colour

  NavbarbgColour: "#19495c",
  NavbarTextColour: "#ffffff",
  TitleBarbgColour: "#f2f4f5",
  TitleBarTextColour: "#19495c",
  typography,
  captions,
};

const textDark = {
Background: "#101414",           // E.g Page background
  CardBackground: "#1a1d1f",       // e.g card background  
  SectionBackground: "#131718",    // e.g background for list like language,skills,etc.,
  Border: "#2e2e2e",               // e.g Button or List or Card Border
  InputBackground: "#2a2d2f",       // input text box background colour
  SpecialButtonBackground: '#FEF7FF',  // e.g Send OTP
  TextPrimary: "#f5f5f5",           // e.g all text for Label,Text
  TextSecondary: "rgba(255,255,255,0.54)",    // e.g for  lable below heading or outside text box
  TextAccent: "#4d9bff",    // e.g for hyperlink or link like Add more
  loader: "#f5f5f5",   // e.g for Activity Indicator 
  IconColor: "#f5f5f5",  // e.g for icon and Image Colour 

  BrandPrimary: "#f3683c",    // Special Button text e.g Send OTP
  BrandSecondary: "#1e5e76",

  ButtonPrimaryBG: "#f3683c",    // e.g Primary Button background Like contiue
  ButtonPrimaryText: "#f5f5f5",  // e.g Primary Button text colour 
  ButtonSecondaryBG: "#1e5e76", // e.g Secndary Button background Like uploadphoto
  ButtonSecondaryText: "#ffffff",  // e.g Secndary Button text Like uploadphoto
  ButtonGhostIcon: "#505050",

  Success: "#2e9e4d",   // e.g for Success Toast Colour
  Warning: "#f5a623",   // e.g for Warning Toast Colour
  Error: "#ff3b30",      // e.g for Error Toast Colour

  NavbarbgColour: "#1e5e76",
  NavbarTextColour: "#ffffff",
  TitleBarbgColour: "#1a1d1f",
  TitleBarTextColour: "#f3683c",
typography,captions
};

// Error color (same for both modes, from PDF brand)
const errorColor = {
  main: "#D32F2F",
  contrastText: "#FFFFFF"
};

// Brand secondary from PDF
const secondaryColor = {
  main: "#19495C", // Brand secondary light
  contrastText: "#FFFFFF"
};

export const themeColors = {
  whitePurple: {
    palette: {
      type: 'light',
      primary: {
        main: "#FFFFFF",
        contrastText: textLight.TextPrimary,
        default: "#101414",
       
      },
      secondary: {
        main: "#7467EF",
        contrastText: "#FFFFFF",
      },
      // background: {
      //   paper: "#FFFFFF",
      //   default: "#FAFAFA",
      // },
       background: {
      paper: textLight.TitleBarbgColour,
        default: textLight.TitleBarbgColour,
        },
      error: errorColor,
      text: textLight,
      border: textLight.Border,
      buttons: {
        primary: {
          bg: textLight.ButtonPrimaryBG,
          text: textLight.ButtonPrimaryText,
        },
        secondary: {
          bg: textLight.ButtonSecondaryBG,
          text: textLight.ButtonSecondaryText,
        },
        ghost: {
          icon: textLight.ButtonGhostIcon,
        },
        special: {
          bg: textLight.SpecialButtonBackground,
          text: textLight.BrandPrimary,
        },
      },
      navbar: {
        bg: textLight.NavbarbgColour,
        text: textLight.NavbarTextColour,
      },
      titlebar: {
        bg: textLight.TitleBarbgColour,
        text: textLight.TitleBarTextColour,
      },
      status: {
        success: textLight.Success,
        warning: textLight.Warning,
        error: textLight.Error,
      },
    },
  },
  whiteBlue: {
    palette: {
      type: 'light',
      primary: {
        main: "#FFFFFF",
        contrastText: textLight.TextPrimary,
      },
      secondary: {
        main: "#1976D2",
        contrastText: "#FFFFFF",
      },
       background: {
      paper: textLight.TitleBarbgColour,
        default: textLight.TitleBarbgColour,
        },
      error: errorColor,
      text: textLight,
      border: textLight.Border,
      buttons: {
        primary: {
          bg: textLight.ButtonPrimaryBG,
          text: textLight.ButtonPrimaryText,
        },
        secondary: {
          bg: textLight.ButtonSecondaryBG,
          text: textLight.ButtonSecondaryText,
        },
        ghost: {
          icon: textLight.ButtonGhostIcon,
        },
        special: {
          bg: textLight.SpecialButtonBackground,
          text: textLight.BrandPrimary,
        },
      },
      navbar: {
        bg: textLight.NavbarbgColour,
        text: textLight.NavbarTextColour,
      },
      titlebar: {
        bg: textLight.TitleBarbgColour,
        text: textLight.TitleBarTextColour,
      },
      status: {
        success: textLight.Success,
        warning: textLight.Warning,
        error: textLight.Error,
      },
    },
  },
  slateDark1: {
    palette: {
      type: 'dark',
      primary: {
        main: "#222A45",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F3683C",
        contrastText: textDark.TextPrimary,
      },
      // background: {
      //   paper: "#1A1D1F",
      //   default: "#101414",
      // },
       background: {
      paper: textDark.TitleBarbgColour,
        default: textDark.TitleBarbgColour,
        },
      error: errorColor,
      text: textDark,
      border: textDark.Border,
      buttons: {
        primary: {
          bg: textDark.ButtonPrimaryBG,
          text: textDark.ButtonPrimaryText,
        },
        secondary: {
          bg: textDark.ButtonSecondaryBG,
          text: textDark.ButtonSecondaryText,
        },
        ghost: {
          icon: textDark.ButtonGhostIcon,
        },
        special: {
          bg: textDark.SpecialButtonBackground,
          text: textDark.BrandPrimary,
        },
      },
      navbar: {
        bg: textDark.NavbarbgColour,
        text: textDark.NavbarTextColour,
      },
      titlebar: {
        bg: textDark.TitleBarbgColour,
        text: textDark.TitleBarTextColour,
      },
      status: {
        success: textDark.Success,
        warning: textDark.Warning,
        error: textDark.Error,
      },
    },
  },
  slateDark2: {
    palette: {
      type: 'dark',
      primary: {
        main: "#1A1D1F",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F3683C",
        contrastText: textDark.TextPrimary,
      },
      // background: {
      //   paper: "#1A1D1F",
      //   default: "#101414",
      // },
       background: {
      paper: textLight.TitleBarbgColour,
        default: textLight.TitleBarbgColour,
        },
      error: errorColor,
      text: textDark,
      border: textDark.Border,
      buttons: {
        primary: {
          bg: textDark.ButtonPrimaryBG,
          text: textDark.ButtonPrimaryText,
        },
        secondary: {
          bg: textDark.ButtonSecondaryBG,
          text: textDark.ButtonSecondaryText,
        },
        ghost: {
          icon: textDark.ButtonGhostIcon,
        },
        special: {
          bg: textDark.SpecialButtonBackground,
          text: textDark.BrandPrimary,
        },
      },
      navbar: {
        bg: textDark.NavbarbgColour,
        text: textDark.NavbarTextColour,
      },
      titlebar: {
        bg: textDark.TitleBarbgColour,
        text: textDark.TitleBarTextColour,
      },
      status: {
        success: textDark.Success,
        warning: textDark.Warning,
        error: textDark.Error,
      },
    },
  },
  purple1: {
    palette: {
      type: 'light',
      primary: {
        main: "#7467EF",
        contrastText: "#FFFFFF",
      },
      secondary: secondaryColor,
      error: errorColor,
      background: {
        paper: "#FFFFFF",
        default: "#FAFAFA",
      },
      text: textLight,
      border: textLight.Border,
      buttons: {
        primary: {
          bg: textLight.ButtonPrimaryBG,
          ghost: textLight.ButtonPrimaryText,
        },
        secondary: {
          bg: textLight.ButtonSecondaryBG,
          text: textLight.ButtonSecondaryText,
        },
        ghost: {
          icon: textLight.ButtonGhostIcon,
        },
        special: {
          bg: textLight.SpecialButtonBackground,
          text: textLight.BrandPrimary,
        },
      },
      navbar: {
        bg: textLight.NavbarbgColour,
        text: textLight.NavbarTextColour,
      },
      titlebar: {
        bg: textLight.TitleBarbgColour,
        text: textLight.TitleBarTextColour,
      },
      status: {
        success: textLight.Success,
        warning: textLight.Warning,
        error: textLight.Error,
      },
    },
  },
  purple2: {
    palette: {
      type: 'light',
      primary: {
        main: "#6A75C9",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F25E21",
        contrastText: textLight.TextPrimary,
      },
      error: errorColor,
      background: {
        paper: "#FFFFFF",
        default: "#FAFAFA",
      },
      text: textLight,
      border: textLight.Border,
      buttons: {
        primary: {
          bg: textLight.ButtonPrimaryBG,
          text: textLight.ButtonPrimaryText,
        },
        secondary: {
          bg: textLight.ButtonSecondaryBG,
          text: textLight.ButtonSecondaryText,
        },
        ghost: {
          icon: textLight.ButtonGhostIcon,
        },
        special: {
          bg: textLight.SpecialButtonBackground,
          text: textLight.BrandPrimary,
        },
      },
      navbar: {
        bg: textLight.NavbarbgColour,
        text: textLight.NavbarTextColour,
      },
      titlebar: {
        bg: textLight.TitleBarbgColour,
        text: textLight.TitleBarTextColour,
      },
      status: {
        success: textLight.Success,
        warning: textLight.Warning,
        error: textLight.Error,
      },
    },
  },
  purpleDark1: {
    palette: {
      type: 'dark',
      primary: {
        main: "#7467EF",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F3683C",
        contrastText: textDark.TextPrimary,
      },
      error: errorColor,
      // background: {
      //   paper: "#1A1D1F",
      //   default: "#101414",
      // },
       background: {
      paper: textDark.TitleBarbgColour,
        default: textDark.TitleBarbgColour,
        },
      text: textDark,
      border: textDark.Border,
      buttons: {
        primary: {
          bg: textDark.ButtonPrimaryBG,
          text: textDark.ButtonPrimaryText,
        },
        secondary: {
          bg: textDark.ButtonSecondaryBG,
          text: textDark.ButtonSecondaryText,
        },
        ghost: {
          icon: textDark.ButtonGhostIcon,
        },
        special: {
          bg: textDark.SpecialButtonBackground,
          text: textDark.BrandPrimary,
        },
      },
      navbar: {
        bg: textDark.NavbarbgColour,
        text: textDark.NavbarTextColour,
      },
      titlebar: {
        bg: textDark.TitleBarbgColour,
        text: textDark.TitleBarTextColour,
      },
      status: {
        success: textDark.Success,
        warning: textDark.Warning,
        error: textDark.Error,
      },
    },
  },
  purpleDark2: {
    palette: {
      type: 'dark',
      primary: {
        main: "#6A75C9",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F3683C",
        contrastText: textDark.TextPrimary,
      },
      error: errorColor,
      // background: {
      //   paper: "#1A1D1F",
      //   default: "#101414",
      // },
       background: {
      paper: textDark.TitleBarbgColour,
        default: textDark.TitleBarbgColour,
        },
      text: textDark,
      border: textDark.Border,
      buttons: {
        primary: {
          bg: textDark.ButtonPrimaryBG,
          text: textDark.ButtonPrimaryText,
        },
        secondary: {
          bg: textDark.ButtonSecondaryBG,
          text: textDark.ButtonSecondaryText,
        },
        ghost: {
          icon: textDark.ButtonGhostIcon,
        },
        special: {
          bg: textDark.SpecialButtonBackground,
          text: textDark.BrandPrimary,
        },
      },
      navbar: {
        bg: textDark.NavbarbgColour,
        text: textDark.NavbarTextColour,
      },
      titlebar: {
        bg: textDark.TitleBarbgColour,
        text: textDark.TitleBarTextColour,
      },
      status: {
        success: textDark.Success,
        warning: textDark.Warning,
        error: textDark.Error,
      },
    },
  },
  blue: {
    palette: {
      type: 'light',
      primary: {
        main: "#1976D2",
        contrastText: textLight.TextPrimary,
        // darknew: "#1b3b5f",
      },
      secondary: {
        main: "#F25E21",
        contrastText: textLight.TextPrimary,
      },
      info: {
        main: "#999999",
        grey: "#888",
        contrastText: "#FFFFFF",
      },
      error: errorColor,
      background: {
        paper: textLight.TitleBarbgColour,
        default: textLight.TitleBarbgColour,
      },
      text: textLight,
      border: textLight.Border,
      card: textLight.CardBackground,
      bgground: textLight.Background,
      icon:textLight.IconColor,
      textInput: textLight.InputBackground,
      textAcc:textLight.TextAccent,
      buttons: {
        primary: {
          bg: textLight.ButtonPrimaryBG,
          text: textLight.ButtonPrimaryText,
        },
        secondary: {
          bg: textLight.ButtonSecondaryBG,
          text: textLight.ButtonSecondaryText,
        },
        ghost: {
          icon: textLight.ButtonGhostIcon,
        },
        special: {
          bg: textLight.SpecialButtonBackground,
          text: textLight.BrandPrimary,
        },
      },
      navbar: {
        bg: textLight.NavbarbgColour,
        text: textLight.NavbarTextColour,
      },
      titlebar: {
        bg: textLight.TitleBarbgColour,
        text: textLight.TitleBarTextColour,
      },
      status: {
        success: textLight.Success,
        warning: textLight.Warning,
        error: textLight.Error,
      },
    },
  },
  blueDark: {
    palette: {
      type: 'dark',
      primary: {
        main: "#1976D2",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F3683C",
        contrastText: textDark.TextPrimary,
      },
      info: {
        main: "#EEEEEE",
        contrastText: "#000000",
      },
      error: errorColor,
      // background: {
      //   paper: "#1A1D1F",
      //   default: "#101414",
      // },
      textAcc:textDark.TextAccent,
       background: {
      paper: textDark.TitleBarbgColour,
        default: textDark.TitleBarbgColour,
        },
      text: textDark,
      bgground: textDark.Background,
      border: textDark.Border,
      card: textDark.CardBackground,
      icon:textDark.IconColor,
       textInput: textDark.InputBackground,
      buttons: {
        primary: {
          bg: textDark.ButtonPrimaryBG,
          text: textDark.ButtonPrimaryText,
        },
        secondary: {
          bg: textDark.ButtonSecondaryBG,
          text: textDark.ButtonSecondaryText,
        },
        ghost: {
          icon: textDark.ButtonGhostIcon,
        },
        special: {
          bg: textDark.SpecialButtonBackground,
          text: textDark.BrandPrimary,
        },
      },
      navbar: {
        bg: textDark.NavbarbgColour,
        text: textDark.NavbarTextColour,
      },
      titlebar: {
        bg: textDark.TitleBarbgColour,
        text: textDark.TitleBarTextColour,
      },
      status: {
        success: textDark.Success,
        warning: textDark.Warning,
        error: textDark.Error,
      },
    },
  },
  red: {
    palette: {
      type: 'dark',
      primary: {
        main: "#E53935",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F3683C",
        contrastText: textDark.TextPrimary,
      },
      error: errorColor,
      // background: {
      //   paper: "#1A1D1F",
      //   default: "#101414",
      // },
       background: {
      paper: textDark.TitleBarbgColour,
        default: textDark.TitleBarbgColour,
        },
      text: textDark,
      border: textDark.Border,
      buttons: {
        primary: {
          bg: textDark.ButtonPrimaryBG,
          text: textDark.ButtonPrimaryText,
        },
        secondary: {
          bg: textDark.ButtonSecondaryBG,
          text: textDark.ButtonSecondaryText,
        },
        ghost: {
          icon: textDark.ButtonGhostIcon,
        },
        special: {
          bg: textDark.SpecialButtonBackground,
          text: textDark.BrandPrimary,
        },
      },
      navbar: {
        bg: textDark.NavbarbgColour,
        text: textDark.NavbarTextColour,
      },
      titlebar: {
        bg: textDark.TitleBarbgColour,
        text: textDark.TitleBarTextColour,
      },
      status: {
        success: textDark.Success,
        warning: textDark.Warning,
        error: textDark.Error,
      },
    },
  },
  whiteBlack: {
    palette: {
      type: 'light',
      primary: {
        main: "#FFFFFF",
        contrastText: textLight.TextPrimary,
      },
      secondary: {
        main: "#F25E21",
        contrastText: textLight.TextPrimary,
      },
      error: errorColor,
      background: {
        paper: "#FFFFFF",
        default: "#FAFAFA",
      },
      text: textLight,
      border: textLight.Border,
      buttons: {
        primary: {
          bg: textLight.ButtonPrimaryBG,
          text: textLight.ButtonPrimaryText,
        },
        secondary: {
          bg: textLight.ButtonSecondaryBG,
          text: textLight.ButtonSecondaryText,
        },
        ghost: {
          icon: textLight.ButtonGhostIcon,
        },
        special: {
          bg: textLight.SpecialButtonBackground,
          text: textLight.BrandPrimary,
        },
      },
      navbar: {
        bg: textLight.NavbarbgColour,
        text: textLight.NavbarTextColour,
      },
      titlebar: {
        bg: textLight.TitleBarbgColour,
        text: textLight.TitleBarTextColour,
      },
      status: {
        success: textLight.Success,
        warning: textLight.Warning,
        error: textLight.Error,
      },
    },
  },
  greenWhite: {
    palette: {
      type: 'light',
      primary: {
        main: "#009688",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#F25E21",
        contrastText: textLight.TextPrimary,
      },
      error: errorColor,
      background: {
        paper: "#FFFFFF",
        default: "#FAFAFA",
      },
      text: textLight,
      border: textLight.Border,
      buttons: {
        primary: {
          bg: textLight.ButtonPrimaryBG,
          text: textLight.ButtonPrimaryText,
        },
        secondary: {
          bg: textLight.ButtonSecondaryBG,
          text: textLight.ButtonSecondaryText,
        },
        ghost: {
          icon: textLight.ButtonGhostIcon,
        },
        special: {
          bg: textLight.SpecialButtonBackground,
          text: textLight.BrandPrimary,
        },
      },
      navbar: {
        bg: textLight.NavbarbgColour,
        text: textLight.NavbarTextColour,
      },
      titlebar: {
        bg: textLight.TitleBarbgColour,
        text: textLight.TitleBarTextColour,
      },
      status: {
        success: textLight.Success,
        warning: textLight.Warning,
        error: textLight.Error,
      },
    },
  },

  // ✅ Repeat same structure for purple1, purple2, purpleDark1, purpleDark2, blue, blueDark, red, whiteBlack, greenWhite
};

  export const themeShadows = [
    'none',
    '0px 2px 1px -1px rgba(0, 0, 0, 0.06),0px 1px 1px 0px rgba(0, 0, 0, 0.042),0px 1px 3px 0px rgba(0, 0, 0, 0.036)',
    '0px 3px 1px -2px rgba(0, 0, 0, 0.06),0px 2px 2px 0px rgba(0, 0, 0, 0.042),0px 1px 5px 0px rgba(0, 0, 0, 0.036)',
    '0px 3px 3px -2px rgba(0, 0, 0, 0.06),0px 3px 4px 0px rgba(0, 0, 0, 0.042),0px 1px 8px 0px rgba(0, 0, 0, 0.036)',
    '0px 2px 4px -1px rgba(0, 0, 0, 0.06),0px 4px 5px 0px rgba(0, 0, 0, 0.042),0px 1px 10px 0px rgba(0, 0, 0, 0.036)',
    '0px 3px 5px -1px rgba(0, 0, 0, 0.06),0px 5px 8px 0px rgba(0, 0, 0, 0.042),0px 1px 14px 0px rgba(0, 0, 0, 0.036)',
    '0px 3px 5px -1px rgba(0, 0, 0, 0.06),0px 6px 10px 0px rgba(0, 0, 0, 0.042),0px 1px 18px 0px rgba(0, 0, 0, 0.036)',
    '0px 4px 5px -2px rgba(0, 0, 0, 0.06),0px 7px 10px 1px rgba(0, 0, 0, 0.042),0px 2px 16px 1px rgba(0, 0, 0, 0.036)',
    '0px 5px 5px -3px rgba(0, 0, 0, 0.06),0px 8px 10px 1px rgba(0, 0, 0, 0.042),0px 3px 14px 2px rgba(0, 0, 0, 0.036)',
    '0px 5px 6px -3px rgba(0, 0, 0, 0.06),0px 9px 12px 1px rgba(0, 0, 0, 0.042),0px 3px 16px 2px rgba(0, 0, 0, 0.036)',
    '0px 6px 6px -3px rgba(0, 0, 0, 0.06),0px 10px 14px 1px rgba(0, 0, 0, 0.042),0px 4px 18px 3px rgba(0, 0, 0, 0.036)',
    '0px 6px 7px -4px rgba(0, 0, 0, 0.06),0px 11px 15px 1px rgba(0, 0, 0, 0.042),0px 4px 20px 3px rgba(0, 0, 0, 0.036)',
    '0px 7px 8px -4px rgba(0, 0, 0, 0.06),0px 12px 17px 2px rgba(0, 0, 0, 0.042),0px 5px 22px 4px rgba(0, 0, 0, 0.036)',
    '0px 7px 8px -4px rgba(0, 0, 0, 0.06),0px 13px 19px 2px rgba(0, 0, 0, 0.042),0px 5px 24px 4px rgba(0, 0, 0, 0.036)',
    '0px 7px 9px -4px rgba(0, 0, 0, 0.06),0px 14px 21px 2px rgba(0, 0, 0, 0.042),0px 5px 26px 4px rgba(0, 0, 0, 0.036)',
    '0px 8px 9px -5px rgba(0, 0, 0, 0.06),0px 15px 22px 2px rgba(0, 0, 0, 0.042),0px 6px 28px 5px rgba(0, 0, 0, 0.036)',
    '0px 8px 10px -5px rgba(0, 0, 0, 0.06),0px 16px 24px 2px rgba(0, 0, 0, 0.042),0px 6px 30px 5px rgba(0, 0, 0, 0.036)',
    '0px 8px 11px -5px rgba(0, 0, 0, 0.06),0px 17px 26px 2px rgba(0, 0, 0, 0.042),0px 6px 32px 5px rgba(0, 0, 0, 0.036)',
    '0px 9px 11px -5px rgba(0, 0, 0, 0.06),0px 18px 28px 2px rgba(0, 0, 0, 0.042),0px 7px 34px 6px rgba(0, 0, 0, 0.036)',
    '0px 9px 12px -6px rgba(0, 0, 0, 0.06),0px 19px 29px 2px rgba(0, 0, 0, 0.042),0px 7px 36px 6px rgba(0, 0, 0, 0.036)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
  ];
  // const textLight = {
//     primary: 'rgba(52, 49, 76, 1)',
//     secondary: 'rgba(52, 49, 76, 0.54)',
//     disabled: 'rgba(52, 49, 76, 0.38)',
//     hint: 'rgba(52, 49, 76, 0.38)',
//   };
  
//   const textDark = {
//     primary: '#fff',
//     secondary: 'rgba(255, 255, 255, 0.7)',
//     disabled: 'rgba(255, 255, 255, 0.64)',
//     hint: 'rgba(255, 255, 255, 0.64)',
//   };
  
//   const secondaryColor = {
//     light: '#f9a352',
//     main: '#ff9e43',
//     dark: '#ff932e',
//     contrastText: textLight.primary,
//   };
//   const errorColor = {
//     main: '#FF3D57',
//   };
  
//   export const themeColors = {
//     whitePurple: {
//       palette: {
//         type: 'light',
//         primary: {
//           main: '#ffffff',
//           contrastText: textLight.primary,
//         },
//         secondary: {
//           main: '#7467ef',
//           contrastText: '#ffffff',
//         },
//         background: {
//           paper: '#fff',
//           default: '#fafafa',
//         },
//         error: errorColor,
//         text: textLight,
//       },
//     },
//     whiteBlue: {
//       palette: {
//         type: 'light',
//         primary: {
//           main: '#ffffff',
//           contrastText: textLight.primary,
//         },
//         secondary: {
//           main: '#1976d2',
//           contrastText: '#ffffff',
//         },
//         background: {
//           paper: '#fff',
//           default: '#fafafa',
//         },
//         text: textLight,
//       },
//     },
//     slateDark1: {
//       palette: {
//         type: 'dark',
//         primary: {
//           main: '#222A45',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#ff9e43',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#222A45',
//           default: '#1a2038',
//         },
//         text: textDark,
//       },
//     },
//     slateDark2: {
//       palette: {
//         type: 'dark',
//         primary: {
//           main: '#1a2038',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#ff9e43',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#222A45',
//           default: '#1a2038',
//         },
//         text: textDark,
//       },
//     },
//     purple1: {
//       palette: {
//         type: 'light',
//         primary: {
//           main: '#7467ef',
//           contrastText: '#ffffff',
//         },
//         secondary: secondaryColor,
//         error: errorColor,
//         background: {
//           paper: '#fff',
//           default: '#fafafa',
//         },
//         text: textLight,
//       },
//     },
//     purple2: {
//       palette: {
//         type: 'light',
//         primary: {
//           main: '#6a75c9',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#ff9e43',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#fff',
//           default: '#fafafa',
//         },
//         text: textLight,
//       },
//     },
//     purpleDark1: {
//       palette: {
//         type: 'dark',
//         primary: {
//           main: '#7467ef',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#ff9e43',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#222A45',
//           default: '#1a2038',
//         },
//         text: textDark,
//       },
//     },
//     purpleDark2: {
//       palette: {
//         type: 'dark',
//         primary: {
//           main: '#6a75c9',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#ff9e43',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#222A45',
//           default: '#1a2038',
//         },
//         text: textDark,
//       },
//     },
//     blue: {
//       palette: {
//         type: 'light',
//         primary: {
//           main: '#1976d2',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#FFAF38',
//           contrastText: textLight.primary,
//         },
//         info: {
//           main: '#999999',
//           contrastText: "#ffffff",
//         },
//         error: errorColor,
//         background: {
//           paper: '#fff',
//           default: '#FAFAFB',
//         },
//         text: textLight,
//       },
//     },
//     blueDark: {
//       palette: {
//         type: 'dark',
//         primary: {
//           main: '#1976d2',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#FF4F30',
//           contrastText: textLight.primary,
//         },
//         info:{
//           main: '#EEEEEE',
//           contrastText: '#000000',
//         },
//         error: errorColor,
//         background: {
//           paper: '#222A45',
//           default: '#1a2038',
//         },
//         text: textDark,
//       },
//     },
//     red: {
//       palette: {
//         type: 'dark',
//         primary: {
//           main: '#e53935',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#FFAF38',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         text: textDark,
//       },
//     },
//     whitBlack: {
//       palette: {
//         type: 'light',
//         primary: {
//           main: '#ffffff',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#FFAF38',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#fff',
//           default: '#fafafa',
//         },
//         text: textLight,
//       },
//     },
//     whiteblack2: {
//       palette: {
//         type: 'light',
//         primary: {
//           main: '#ffffff',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#ff9e43',
//           contrastText: textLight.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#222A45',
//           default: '#1a2038',
//         },
//         text: textLight,
//       },
//     },
//     greenWhite: {
//       palette: {
//         type: 'light',
//         primary: {
//           // main: '#637381',
//           main: '#009688',
//           contrastText: '#ffffff',
//         },
//         secondary: {
//           main: '#FFAF38',
//           contrastText: textDark.primary,
//         },
//         error: errorColor,
//         background: {
//           paper: '#00695f',
//           default: '#fafafa',
//         },
//         text: textDark,
//       },
//     },
//   };
  



// export const themeColors = {
//   whitePurple: {
//     palette: {
//       type: 'light',
//       primary: {
//         main: "#FFFFFF", // Canvas
//         contrastText: textLight.primary,
//       },
//       secondary: {
//         main: "#7467EF", // Not in PDF, kept original accent
//         contrastText: "#FFFFFF",
//       },
//       background: {
//         paper: "#FFFFFF", // Canvas
//         default: "#FAFAFA", // Milk
//       },
//       error: errorColor,
//       text: textLight,
//     },
//   },
//   whiteBlue: {
//     palette: {
//       type: 'light',
//       primary: {
//         main: "#FFFFFF",
//         contrastText: textLight.primary,
//       },
//       secondary: {
//         main: "#1976D2", // Blue accent (custom)
//         contrastText: "#FFFFFF",
//       },
//       background: {
//         paper: "#FFFFFF",
//         default: "#FAFAFA",
//       },
//       text: textLight,
//     },
//   },
//   slateDark1: {
//     palette: {
//       type: 'dark',
//       primary: {
//         main: "#222A45",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F3683C", // Primary brand dark
//         contrastText: textLight.primary,
//       },
//       error: errorColor,
//       background: {
//         paper: "#1A1D1F", // Surface-Deep
//         default: "#101414", // Night-Sky
//       },
//       text: textDark,
//     },
//   },
//   slateDark2: {
//     palette: {
//       type: 'dark',
//       primary: {
//         main: "#1A1D1F",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F3683C",
//         contrastText: textLight.primary,
//       },
//       error: errorColor,
//       background: {
//         paper: "#1A1D1F",
//         default: "#101414",
//       },
//       text: textDark,
//     },
//   },
//   purple1: {
//     palette: {
//       type: 'light',
//       primary: {
//         main: "#7467EF",
//         contrastText: "#FFFFFF",
//       },
//       secondary: secondaryColor,
//       error: errorColor,
//       background: {
//         paper: "#FFFFFF",
//         default: "#FAFAFA",
//       },
//       text: textLight,
//     },
//   },
//   purple2: {
//     palette: {
//       type: 'light',
//       primary: {
//         main: "#6A75C9",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F25E21", // Brand primary light
//         contrastText: textLight.primary,
//       },
//       error: errorColor,
//       background: {
//         paper: "#FFFFFF",
//         default: "#FAFAFA",
//       },
//       text: textLight,
//     },
//   },
//   purpleDark1: {
//     palette: {
//       type: 'dark',
//       primary: {
//         main: "#7467EF",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F3683C",
//         contrastText: textLight.primary,
//       },
//       error: errorColor,
//       background: {
//         paper: "#1A1D1F",
//         default: "#101414",
//       },
//       text: textDark,
//     },
//   },
//   purpleDark2: {
//     palette: {
//       type: 'dark',
//       primary: {
//         main: "#6A75C9",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F3683C",
//         contrastText: textLight.primary,
//       },
//       error: errorColor,
//       background: {
//         paper: "#1A1D1F",
//         default: "#101414",
//       },
//       text: textDark,
//     },
//   },
//   blue: {
//     palette: {
//       type: 'light',
//       primary: {
//         main: "#1976D2",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F25E21", // Brand primary light
//         contrastText: textLight.primary,
//       },
//       info: {
//         main: "#999999",
//         contrastText: "#FFFFFF",
//       },
//       error: errorColor,
//       background: {
//         paper: "#FFFFFF",
//         default: "#FAFAFA",
//       },
//       text: textLight,
//     },
//   },
//   blueDark: {
//     palette: {
//       type: 'dark',
//       primary: {
//         main: "#1976D2",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F3683C",
//         contrastText: textLight.primary,
//       },
//       info: {
//         main: "#EEEEEE",
//         contrastText: "#000000",
//       },
//       error: errorColor,
//       background: {
//         paper: "#1A1D1F",
//         default: "#101414",
//       },
//       text: textDark,
//     },
//   },
//   red: {
//     palette: {
//       type: 'dark',
//       primary: {
//         main: "#E53935",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F3683C",
//         contrastText: textLight.primary,
//       },
//       error: errorColor,
//       text: textDark,
//     },
//   },
//   whiteBlack: {
//     palette: {
//       type: 'light',
//       primary: {
//         main: "#FFFFFF",
//         contrastText: textLight.primary,
//       },
//       secondary: {
//         main: "#F25E21",
//         contrastText: textLight.primary,
//       },
//       error: errorColor,
//       background: {
//         paper: "#FFFFFF",
//         default: "#FAFAFA",
//       },
//       text: textLight,
//     },
//   },
//   greenWhite: {
//     palette: {
//       type: 'light',
//       primary: {
//         main: "#009688",
//         contrastText: "#FFFFFF",
//       },
//       secondary: {
//         main: "#F25E21",
//         contrastText: textDark.primary,
//       },
//       error: errorColor,
//       background: {
//         paper: "#FFFFFF",
//         default: "#FAFAFA",
//       },
//       text: textLight,
//     },
//   },
// };